<style lang="scss">
    .main {
        width: 100%;
        min-width: 1200px;
        background: white;
        padding: 0;
        margin: 0;
        font-size: 14px;
        color: #444;
    }
    button{
        border: 0;
        outline: none;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
    }
    .card{
        margin-left: auto;
        margin-right: auto;
        box-shadow: 0 0 10px #eee;
    }
    .text-center{
        text-align: center;
    }

    a {
        color: #555;
        text-decoration: none;
    }

    .a-orange a {
        color: #FF9F11;
        text-decoration: none;
    }
    .orange{
        color: #FF9F11;
    }

    .container {
        width: 1200px;
        margin: auto;
    }

    ul, li, dl, dt, dd {
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .clearfix {
        overflow: auto;
        _height: 1%
    }

    .icon-xian {
        height: 50px;
        background: url("../assets/frontend/images/icon_xian@2x.png") center no-repeat;
    }

    .page-header {
        padding-top: 60px;

        h2 {
            font-size: 24px;
            text-align: center;
            font-weight: 600;
            margin: 0;
            padding: 0;
        }
    }

    .rowflex{
        display: flex;
        flex-direction: row;
    }

    .watchword {
        text-align: center;
        padding: 70px 0;
    }
    .red{
        color: #e23844;
    }

    .pagination {
        text-align: center;

        .el-pager li {
            height: 36px;
            line-height: 36px;
        }

        .el-pagination.is-background .btn-next,
        .el-pagination.is-background .btn-prev,
        .el-pagination.is-background .el-pager li {
            min-width: 36px;
        }

        .el-pagination.is-background .btn-next,
        .el-pagination.is-background .btn-prev,
        .el-pagination.is-background .el-pager li:hover {
            color: #7cb85a;
        }
        .el-pagination.is-background .el-pager li.active:hover {
            color: #fff;
        }

        .el-pagination button,
        .el-pagination span:not([class*=suffix]) {
            height: 36px;
            line-height: 36px;
        }

        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background: #7cb85a;
        }
    }
    .wechat_service {
        min-width: 400px;
    }
</style>
<style lang="scss" scoped>
    .topbg {
        height: 40px;
        background: #f6f6f6;

        .top {
            display: flex;
            flex-direction: row;

            .left, .right {
                flex: 1;
            }

            .left {
                line-height: 40px;
            }

            .right {
                text-align: right;
                padding-top: 9px;

                .el-dropdown-link {
                    cursor: pointer;
                    color: #555;
                }

                .el-icon-arrow-down {
                    font-size: 12px;
                }


            }
        }
    }

    .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: #f1f9ec;
        color: #90ca6f;
    }

    .head {
        padding: 40px 0 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .txt-logo {
            width: 220px;

            h1, h3 {
                margin: 0;
                padding: 0;
                font-weight: 500;
            }

            h3 {
                color: #888;
                font-weight: 500;
                font-size: 16px;
                margin-top: 3px;
            }
        }

        .search-group {
            width: 700px;
            display: flex;
            align-items: center;

            flex-direction: row;

            img {
                width: 47px;
                height: 47px;
            }

            .search-input {
                flex: 1;
            }

            ::v-deep .el-input__inner {
                border: 1px solid #90ca6f;
            }

            ::v-deep .el-input-group__append, .el-input-group__prepend {
                background-color: #90ca6f;
                color: #fff;
                border: 1px solid #90ca6f;
                font-size: 20px;
            }
        }

        .shopingCar, .express {
            position: relative;
            text-decoration: none;
            display: block;
            width: 80px;
            height: 80px;
            text-align: center;
            color: #555;

            i {
                font-size: 24px;
                padding: 8px;
                border-radius: 50px;
                background: #90CA6F;
                color: white;
            }

            p {
                font-size: 12px;
                margin: 0;
                padding: 15px 0 0;
            }
        }
        .cartdot {
            position: absolute;
            right:10px;
            top:-15px;
            color: #fff;
            width: 20px;
            height: 20px;
            border-radius: 20px;
            background: red;
        }
    }

    .nav {
        background: #90CA6F;
        height: 40px;

        a {
            display: inline-block;
            width: 16.5%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: white;
        }

        a:hover {
            background: #86B66B;
        }

        ::v-deep .router-link-exact-active {
            background: #7CA267;
        }
    }

    .footer {
        background: #282828;
        padding: 50px 0;

        .container {
            display: flex;
            flex-direction: row;
            color: #c0c0c0;

            a {
                color: #c0c0c0;
            }

            a:hover {
                text-decoration: underline;
            }

            dl {
                flex: 1;
                line-height: 26px;

                dt {
                    margin: 0;
                    padding: 0;
                    font-size: 20px;
                    padding-bottom: 10px;
                }

                dd {
                    padding: 0;
                    margin-left: 0;
                    margin-inline-start: 0px;
                    width:80%;
                    height:24px;
                    line-height:24px;
                    overflow:hidden;
                }

            }

            dl:last-child {
                padding-right: 30px;
            }

            dl:first-child {
                padding-left: 50px;
            }
        }
    }
</style>
<template>
    <div class="main">
        <div class="topbg">
            <div class="container">
                <div class="top">
                    <div class="left a-orange">欢迎来到澳尚健康！
                        <template v-if="!isLogin">
                        <router-link to="/login">【登录】</router-link>
                        <router-link to="/register">【注册】</router-link>
                        </template>
                    </div>
                    <div class="right">
                        <el-dropdown trigger="click">
                            <span class="el-dropdown-link">
                                English<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="skipTo('zh-Hans')">简体中文</el-dropdown-item>
                                <el-dropdown-item @click.native="skipTo('en')">English</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-dropdown v-if="isLogin">
                          <span class="el-dropdown-link" style="margin-left: 25px;">
                            昵称：{{userId}}<i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                            <el-dropdown-menu slot="dropdown" class="user-dropdown">
                                <el-dropdown-item @click.native="$router.push({path:'/orders'})">我的订单</el-dropdown-item>
                                <el-dropdown-item @click.native="$router.push({path:'/expresses'})">我的快递</el-dropdown-item>
                                <el-dropdown-item @click.native="$router.push({path:'/receiptor'})">我的收件人</el-dropdown-item>
                                <el-dropdown-item @click.native="$router.push({path:'/myCenter'})" divided>我的资料</el-dropdown-item>
                                <el-dropdown-item @click.native="$router.push({path:'/password'})">修改密码</el-dropdown-item>
                                <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="head">
                <div class="txt-logo">
                    <h1>澳尚健康</h1>
                    <h3>我们只是澳洲奶粉的搬运工</h3>
                </div>
                <div class="search-group">
                    <img src="@/assets/frontend/images/logo.png" alt=""/>
                    <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="searchKeywords" type="text"
                              class="search-input" clearable @keyup.enter.native="topToSearch()">
                        <el-button slot="append" @click="topToSearch()">搜索</el-button>
                    </el-input>
                </div>
                <router-link to="/shoppingcart" class="shopingCar">
                    <i class="iconfont icon-gouwuche"></i>
                    <p>我的购物车</p>
                    <span class="cartdot" v-if="shoppingCart && shoppingCart > 0">{{shoppingCart}}</span>
                </router-link>
                <router-link to="/expresses?type=1" class="express">
                    <i class="iconfont icon-kuaidiyunshu"></i>
                    <p>我要寄快递</p>
                </router-link>
            </div>
        </div>
        <div class="nav">
            <div class="container">
                <router-link to="/" class="active">商城首页</router-link>
                <router-link to="/news">新闻中心</router-link>
                <router-link to="/orders">我的订单</router-link>
                <router-link to="/expresses">我的快递</router-link>
                <a href="javascript:void(0)" @click="customServiceDialog=true">联系客服</a>
                <!--<router-link @click.native="customService" to="/customService">联系客服</router-link>-->
                <router-link to="/about">关于我们</router-link>
            </div>
        </div>

        <el-dialog
            title="微信客服"
            :visible.sync="customServiceDialog"
            width="30%" custom-class="wechat_service">
            <div class="text-center">
                <img :src="appConfig.serviceWechatQRCode" alt="" width="200" height="245" />
                <p>请用微信扫描上面的二维码加客服微信，您有任何问题都可以随时咨询客服哦!</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="customServiceDialog = false">关 闭</el-button>
              </span>
        </el-dialog>

        <router-view></router-view>

        <div class="footer">
            <div class="container">
                <dl>
                    <dt>支付方式</dt>
                    <dd>
                        微信跨境支付
                    </dd>
                    <dd>
                        支付宝跨境支付
                    </dd>
                    <dd>
                        澳洲银行转账
                    </dd>
                    <dd>
                        余额、优惠券支付
                    </dd>
                </dl>
                <dl>
                    <dt>购物指南</dt>
                    <dd v-for="item in guides">
                        <router-link :to="{path: '/news', query: {category:item.category}}" :title="item.title">{{item.title}}</router-link>
                    </dd>
                </dl>
                <dl>
                    <dt>联系我们</dt>
                    <div>
                        地址：{{appConfig.contactAddress}}<br/>
                        邮箱：{{appConfig.contactEmail}}<br/>
                        微信：{{appConfig.contractWechat}}
                    </div>
                </dl>
            </div>
        </div>
    </div>


</template>

<script>
    // @ is an alias to /src
    import shopCart from '@/js/mixins/shopCart.js'
    export default {
        name: 'frontend',
        components: {
            // HelloWorld
        },
        mixins: [shopCart],
        data () {
            return {
                user: null,
                isCollapse: false,
                customServiceDialog:false,
                searchKeywords: "",
                appConfig: {},
                problems: [],
                guides: []
            }
        },
        created () {
            this.getUserInfo();
            this.getAppSetting();
            this.getProblem();
            this.getGuide();
        },
        watch: {
            '$route'(){
                let query = this.$route.query;
                this.searchKeywords = query.keywords || "";
            }
        },
        computed: {
            userId(){
                let user = this.$store.state.user;
                return user ? user.uid : "";
            },
            isLogin(){
                let user = this.$store.state.user;
                console.log(user);
                return user && user.id > 0; 
            },
            shoppingCart () {
                let cartStore = this.getShopCartLocalStroage();
                let count = cartStore && cartStore.length || "";
                return this.$store.state.shoppingCart.count || count
            }
        },
        methods: {
            logout(){
                this.$confirm('确定要退出吗？', '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('userLogout');
                    localStorage.removeItem(window.consts.strings.userToken)
                    location.reload();
                }).catch(() => { });
            },
            customService(){

            },
            getUserInfo(){
                let token = localStorage.getItem('as_user_token');
                if(token){
                    console.log('获取用户信息')
                    this.axios.get(window.consts.apis.getMyInfo).then(res=>{
                        if(res.success && res.result && res.result.id>0){
                            this.$store.dispatch('setUser', {
                                id: res.result.id,
                                uid: res.result.name,
                                mobile: res.result.phoneNumber,
                                email: '',
                                lastLogin: ''
                            })
                        }
                    })
                } else {
                    this.$store.dispatch('userLogout');
                    localStorage.removeItem(window.consts.strings.userToken)
                }
            },
            getAppSetting() {
                this.axios.get(window.consts.apis.getAppSetting).then(res=>{
                    if(res.success && res.result){
                        this.appConfig = res.result
                    }
                })
            },
            topToSearch() {
                /*this.$store.dispatch('searchTools', {
                    keywords: this.searchKeywords
                })*/
                let query = this.$route.query;
                let cateId = query.cateId || 0;
                let brandId = query.brandId || 0;
                let hotSale = query.hotSale === true || query.hotSale == "true" ? true : false;
                let preferential = query.preferential === true || query.preferential == "true" ? true : false;
                let keywords = this.searchKeywords || "";
                let params = { cateId, brandId, hotSale, preferential, keywords }
                let pathName = location.pathname;
                let isProducts = pathName.indexOf("products") != -1 ? true : false;
                if (keywords) {
                    this.$router.push({ path:'/products', query: params });
                } else {
                    if (isProducts) {
                        this.$router.push({ path:'/products', query: params });
                    }
                }
            },
            getProblem() {
                this.$axios.get(window.consts.apis.getTopList, { params: { category: "常见问题", takeNumber: 5 } }).then(res => {
                    if (res.success) {
                        this.problems = res.result;
                    }
                }).catch(e => {

                });
            },
            getGuide() {
                this.$axios.get(window.consts.apis.getTopList, { params: { category: "购物指南", takeNumber: 5 } }).then(res => {
                    if (res.success) {
                        this.guides = res.result;
                    }
                }).catch(e => {

                });
            },
            skipTo(param) {
                let backUrl = location.href
                backUrl = decodeURIComponent(backUrl)
                console.log(backUrl)
                if (backUrl.indexOf("?") != -1) {
                    let getRequest = this.getRequest()
                    let languageVal = getRequest["language"]
                    if (languageVal == undefined) {
                        backUrl = backUrl + "&language=" + param
                    } else {
                        let regx = "language=" + languageVal
                        backUrl = backUrl.replace(regx, "language=" + param)
                    }
                } else {
                    backUrl = backUrl + "?language=" + param
                }
                backUrl = backUrl.replace("://")
                let index = backUrl.indexOf("/")
                backUrl = backUrl.substr(index)
                backUrl = encodeURIComponent(backUrl)
                console.log(backUrl)
                let url = "/AbpLocalization/ChangeCulture?cultureName=" + param + "&returnUrl=" + backUrl
                //window.location.replace(url)
                window.location.href = url
            }
        }
    }
</script>
